import {
    // FILE_UPLOAD,
    CREATE_SJFDASHBOARD,
    RETRIEVE_SJFDASHBOARD,
    RETRIEVESINGLE_SJFDASHBOARD,
    UPDATE_SJFDASHBOARD,
    DELETE_SJFDASHBOARD,
} from "./type";
import SJFDashboard from "../service/sjfDashboard";
// export const fileUpload = (data) => async (dispatch) => {
//   try {
//     const res = await SJFDashboard.fileUpload(data);
//     dispatch({
//       type: FILE_UPLOAD,
//       payload: res.data.data,
//     });
//     return Promise.resolve(res.data);
//   } catch (err) {
//     return Promise.reject(err);
//   }
// };
export const create = (data) => async (dispatch) => {
    try {
        const res = await SJFDashboard.create(data);
        dispatch({
            type: CREATE_SJFDASHBOARD,
            payload: res.data,
        });
        return Promise.resolve(res.data);
    } catch (err) {
        return Promise.reject(err);
    }
};
export const retrieve = (data) => async (dispatch) => {
    try {
        const res = await SJFDashboard.fetchList(data);
        dispatch({
            type: RETRIEVE_SJFDASHBOARD,
            status: '',
            response: {},
            payload: res.data.data,
        });
        return Promise.resolve(res.data.data);
    } catch (err) {
        console.log(err);
        return Promise.reject(err);
    }
};
export const retrieveSingle = (data) => async (dispatch) => {
    try {
        const res = await SJFDashboard.fetchSingle(data);
        // dispatch({
        //     type: RETRIEVESINGLE_SJFDASHBOARD,
        //     status: '',
        //     response: {},
        //     payload: res.data.data,
        // });
        return Promise.resolve(res.data.data);
    } catch (err) {
        console.log(err);
        return Promise.reject(err);
    }
};
export const update = (data) => async (dispatch) => {
    try {
        const res = await SJFDashboard.update(data);
        dispatch({
            type: UPDATE_SJFDASHBOARD,
            status: '',
            response: {},
            payload: res.data,
        });
        return Promise.resolve(res.data);
    } catch (err) {
        return Promise.reject(err);
    }
};
// export const changeStatus = (data) => async (dispatch) => {
//     try {
//         const res = await SJFDashboard.changeStatus(data);
//         dispatch({
//             type: UPDATE_SJFDASHBOARD,
//             status: '',
//             response: {},
//             payload: res.data,
//         });
//         return Promise.resolve(res.data);
//     } catch (err) {
//         return Promise.reject(err);
//     }
// };
export const trash = (data) => async (dispatch) => {
    try {
        const res = await SJFDashboard.trash(data);
        dispatch({
            type: DELETE_SJFDASHBOARD,
            status: '',
            response: {},
            payload: res.data,
        });
        return Promise.resolve(res.data);
    } catch (err) {
        return Promise.reject(err);
    }
};